import { render, staticRenderFns } from "./ContentParsed.vue?vue&type=template&id=48ab58e5"
import script from "./ContentParsed.vue?vue&type=script&lang=js"
export * from "./ContentParsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports